import Image from 'next/image';
import { useState } from 'react';
import { replaceCDNToS3Url } from '@/util/url';
import { getScreenElementStyle } from '@/util/canvas';
import { ICanvasElement } from '@/interface/canvas';

export const ImagePreview = ({ element }: IImagePreviewProps) => {
  const [error, setError] = useState<string | undefined>(undefined);
  const style = getScreenElementStyle(element);

  return (
    <>
      {error ? (
        <img
          alt=""
          className="selector"
          id={element.id}
          src={replaceCDNToS3Url(element?.uri || '')}
          width={style.width}
          height={style.height}
          style={style}
        />
      ) : (
        <Image
          alt=""
          className="selector"
          id={element.id}
          src={element?.uri || ''}
          width={style.width}
          height={style.height}
          style={style}
          // eslint-disable-next-line no-console
          onError={() => setError('Error in loading')}
          loading="lazy"
        />
      )}
    </>
  );
};
type IImagePreviewProps = {
  element: ICanvasElement;
};
export default ImagePreview;
